import { call, put } from 'redux-saga/effects'

import { caricaEventiGirlsDefense } from '../../services/community'
import { loadedEvents, failedEvents } from '../actions'

// Eventi da defense.community (flag "Pubblica su girlsdefense.it")
export function* loadEventsSaga() {
  try {
    const list = yield call(caricaEventiGirlsDefense)
    yield put(loadedEvents(list))
  } catch (error) {
    console.log(error)
    yield put(failedEvents())
  }
}
